import { useEffect, useState } from "react";
import { api } from "@/lib/api";
import { DocViewer, DocCheckRow, ConsentRow, SectionTitle, acceptText } from "@/components/legal/LegalParts";

export const useRegistrationLegal = () => {
  const [data, setData] = useState({ documents: [], consents: [] });
  const [checked, setChecked] = useState({});
  const [consents, setConsents] = useState({});
  useEffect(() => { api.get("/public/legal/registration").then(({ data: d }) => setData(d)).catch(() => {}); }, []);
  const ready = data.documents.filter((d) => d.required).every((d) => checked[d.version_id]);
  const payload = () => ({ legal_accepted: Object.keys(checked).filter((k) => checked[k]), consents: Object.keys(consents).filter((k) => consents[k]) });
  const reset = () => { setChecked({}); setConsents({}); };
  return { data, checked, setChecked, consents, setConsents, ready, payload, reset };
};

export function RegistrationLegal({ state }) {
  const [open, setOpen] = useState(null);
  const { data, checked, setChecked, consents, setConsents } = state;
  if (!data.documents.length && !data.consents.length) return null;
  return (
    <div className="md:col-span-2 space-y-4 text-left" data-testid="registration-legal">
      {data.documents.length > 0 && (
        <div className="space-y-2">
          <SectionTitle title="Zorunlu sözleşme ve bildirimler" text="Kaydın tamamlanması için onaylanmalıdır. Başlığa tıklayarak tam metni okuyabilirsiniz." />
          {data.documents.map((d) => <DocCheckRow key={d.id} doc={d} checked={!!checked[d.version_id]} onChange={(v) => setChecked({ ...checked, [d.version_id]: v })} onOpen={() => setOpen(d)} />)}
        </div>
      )}
      {data.consents.length > 0 && (
        <div className="space-y-2">
          <SectionTitle title="İsteğe bağlı izinler" text="Zorunlu değildir; kayıt olmanızı etkilemez. Sonradan geri alabilirsiniz." />
          {data.consents.map((c) => <ConsentRow key={c.id} doc={c} value={consents[c.version_id]} onChange={(v) => setConsents({ ...consents, [c.version_id]: v })} onOpen={() => setOpen(c)} />)}
        </div>
      )}
      <DocViewer doc={open} onClose={() => setOpen(null)} acceptLabel={open && acceptText(open)}
        onAccept={open && open.kind !== "CONSENT" ? () => setChecked((c) => ({ ...c, [open.version_id]: true })) : null} />
    </div>
  );
}
